import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import {CommonModuleModule} from "../../../../modules/common-module/common-module.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommonModuleModule
  ],
  exports: [],
  declarations: []
})
export class EditarUsuarioPageModule {}
